package org.braunequip.web.util

import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba

enum class Theme(
    val hex: String,
    val rgb: CSSColorValue
) {
    Primary(
        hex = "#00A2FF",
        rgb = rgb(r = 0 , g = 162, b = 255)
    ),
    Secondary(
        hex = "#1317F",
        rgb = rgb(19, 23, 31)
    ),
    PrimaryGreen(
        hex = "#00A2FF",
        rgb = rgb(r = 94 , g = 220, b = 64)
    ),
    LightGray(
        hex = "#FAFAFA",
        rgb = rgb(250, 250, 250)
    ),
    DarkGray(
        hex = "#323232",
        rgb = rgb(50, 50, 50)
    ),
    DarkerGray(
        hex = "",
        rgb = rgba(28, 28, 28, 0.9)
    ),
    HalfWhite(
        hex = "#FFFFF",
        rgb = rgba(255, 255, 255, a = 0.5)
    ),
    White(
        hex = "#FFFFF",
        rgb = rgb(255, 255, 255)
    ),
    Black(
        hex = "#000000",
        rgb = rgb(r = 0, b = 0, g = 0)
    ),
    HalfBlack(
        hex = "#000000",
        rgb = rgba(r = 0, b = 0, g = 0, a = 0.5)
    ),

    Green(
        hex = "#00FF94",
        rgb = rgb(r = 0, g = 255, b = 148)
    ),
    Yellow(
        hex = "#FFEC45",
        rgb = rgb(r = 255, g = 236, b = 69)
    ),
    Red(
        hex = "#FF6359",
        rgb = rgb(r = 255, g = 99, b = 89)
    ),
    Purple(
        hex = "#8B6DFF",
        rgb = rgb(r = 139, g= 109, b = 255)
    )
}